import UserList from "../../components/user/UserList";

const UserListPage = () => {
  return <UserList />;
};

export default UserListPage;
